module.exports = __webpack_public_path__ + "36b429582d8747a6799ccbe3d6a94c7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/support.svg
// module id = 785
// module chunks = 0